import { vShow as _vShow, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = ["disablePictureInPicture"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_VideoBottomBar = _resolveComponent("VideoBottomBar")

  return (_openBlock(), _createElementBlock("div", {
    id: $options.screenContainerId,
    class: "screenContainer",
    onDblclickCapture: _cache[0] || (_cache[0] = (...args) => ($setup.onDoubleClick && $setup.onDoubleClick(...args)))
  }, [
    _withDirectives(_createElementVNode("video", {
      ref: "screen",
      disablePictureInPicture: !$props.isBig ? 'true' : 'false',
      class: _normalizeClass(["screen", $setup.screenClass])
    }, null, 10, _hoisted_2), [
      [_vShow, ($props.localMediaModel && $props.localMediaModel.attributes.localScreen) || ($props.callParticipantModel && $props.callParticipantModel.attributes.screen)]
    ]),
    ($props.isBig)
      ? (_openBlock(), _createBlock(_component_VideoBottomBar, {
          key: 0,
          token: $props.token,
          "shared-data": $props.sharedData,
          "is-big": "",
          "is-screen": "",
          model: $options.model,
          "participant-name": $options.remoteParticipantName
        }, null, 8, ["token", "shared-data", "model", "participant-name"]))
      : _createCommentVNode("", true)
  ], 40, _hoisted_1))
}